import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { LmAssignDialog } from './leadmgmt/LmAssignDialog';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const QuickReassignDialog = ({ leadIds, onClose }) => {
  const [users, setUsers] = useState([]);
  useEffect(() => {
    if (!leadIds?.length) return;
    axios.get(`${API_URL}/leads/assignable-users`)
      .then((r) => setUsers((r.data || []).sort((a, b) => (a.name || '').localeCompare(b.name || '', 'pt'))))
      .catch(() => setUsers([]));
  }, [leadIds]);
  return (
    <LmAssignDialog mode={leadIds?.length ? 'single' : null} leadIds={leadIds || []} users={users}
      onClose={onClose} onDone={onClose} />
  );
};
